import { GoogleLogin, type CredentialResponse } from "@react-oauth/google";
import { Box } from "@mui/material";
import axiosInstance from "utils/request";
import t from "./translations";

interface Props {
  configId: number;
  onLogin: () => void;
  onError: (message: string) => void;
}

export function GoogleLoginButton({ configId, onLogin, onError }: Props) {
  async function handleSuccess(response: CredentialResponse) {
    if (!response.credential) {
      onError(t.googleLoginFailed);
      return;
    }
    try {
      await axiosInstance.post("/auth/oauth/google", {
        configId,
        token: response.credential,
      });
      onLogin();
    } catch {
      onError(t.googleLoginFailed);
    }
  }

  return (
    <Box sx={{ mt: 1, width: "100%" }}>
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={() => onError(t.googleLoginFailed)}
        width="100%"
        text="continue_with"
        type="standard"
      />
    </Box>
  );
}
